import { useEffect } from "react";
import Stack from "@mui/material/Stack";
import { ProductBreadcrumbs } from "./ProductBreadcrumbs";
import { ProductSummary } from "./ProductSummary";
import { CompanyCountCard } from "./CompanyCountCard";
import { useProductInstallQuery } from "./hooks/useProductInstallQuery";
import { CompanyTableCard } from "./CompanyTableCard";
import { CategoryHierarchyCard } from "./CategoryHierarchyCard";
import { ProductAttributes } from "./ProductAttributes";
import { ProductHeader } from "./ProductHeader";
import { useProductData } from "./hooks/useProductData";
import { useProductCatalogContext } from "../ProductCatalogContext";
import { useCommandPaletteStore } from "@/store/commandPalette/commandPaletteStore";

export const ProductPage = () => {
  const { product, category, vendor, isLoading } = useProductData();
  const addRecentItem = useCommandPaletteStore((s) => s.addRecentItem);

  const { entityTypeFilterValue, localizeInstalls } =
    useProductCatalogContext();

  const [installQueryResult, installQueryLoading] = useProductInstallQuery(
    product.id,
    localizeInstalls,
    entityTypeFilterValue
  );

  useEffect(() => {
    if (product?.id && product?.name) {
      addRecentItem({
        id: String(product.id),
        type: "product",
        name: product.name,
        route: `/catalog/product/product/${product.id}`,
      });
    }
  }, [product?.id, product?.name, addRecentItem]);

  return (
    <Stack gap={3}>
      <ProductBreadcrumbs productName={product.name} isLoading={isLoading} />

      <ProductHeader productName={product.name} isLoading={isLoading} />

      <ProductSummary
        isLoading={isLoading}
        productDescription={product.description}
        productName={product.name}
        vendorId={vendor?.id}
        vendorName={vendor?.name}
        vendorUrl={vendor?.url}
      />

      <CompanyCountCard
        companyCount={installQueryResult.count}
        loading={installQueryLoading || isLoading}
      />

      <CompanyTableCard
        productId={product.id}
        productName={product.name}
        data={installQueryResult.data}
        loading={installQueryLoading || isLoading}
      />

      <CategoryHierarchyCard
        categoryNameTree={category.nameTree}
        productName={product.name}
      />

      <ProductAttributes
        productAttributes={product.attributes}
        productName={product.name}
      />
    </Stack>
  );
};
